import * as React from "react";
import { cn } from "@/lib/utils";
import { fileService } from "@/services/file-service";
import { useEffect, useState } from "react";

interface CustomImageProps
  extends Omit<React.ImgHTMLAttributes<HTMLImageElement>, "src"> {
  fileId: string;
  className?: string;
  tenantId?: string;
}

export const PresignedImage = ({
  fileId,
  className,
  alt,
  tenantId,
  ...props
}: CustomImageProps) => {
  const [src, setSrc] = useState<string>("");

  useEffect(() => {
    const loadImage = async () => {
      const signedUrl = await fileService.getSignedUrl(fileId, tenantId);
      setSrc(signedUrl);
    };
    if (fileId) {
      loadImage();
    }
  }, [fileId, tenantId]);

  if (!src) return null;

  return <img src={src} alt={alt} className={cn("", className)} {...props} />;
};
